import React from "react";
import {Footer} from "antd/lib/layout/layout";
import {Col, Row} from "antd";
import {useHistory} from "react-router-dom";
import {Spacer} from "../../../components/DesignSystem/Spacer/Spacer";
import {PageFooterLink} from "./PageFooterLink";

export const PageFooter = () => {

    let history = useHistory();

    return <Footer style={{ backgroundColor: 'white'}}>
        <Spacer border={true} size={"large"}/>
        <Spacer size={"medium"}/>
        <PageFooterLink/>
        <Spacer border={true} size={"large"}/>
        {/*<Spacer size={"medium"}/>*/}
        <Row align={"middle"}>
            <Col sm={12}>
                ©  2025 apimoon. All rights reserved.
            </Col>
            <Col sm={12} style={{textAlign: 'right'}}>
                <a href="/terms-and-conditions" className={"footer-link"}>Terms and conditions</a>
                &nbsp;&nbsp;<a href="/privacy-policy" className={"footer-link"}>Privacy policy</a>
                &nbsp;&nbsp;<a href="/cookies-policy" className={"footer-link"}>Cookies policy</a>
            </Col>
        </Row>

    </Footer>

}